<template>
  <Modal v-model="carrierTableModal" :title="modalTitle" width="900" :transfer="false" :mask-closable="false"
    class-name="carrierTableModalStyle" @on-visible-change="carrierTableModalChange">
    <div class="carrier_table_filter">
      <span>{{ $t('key1000424') }}</span>
      <Input v-model.trim="pageParams.nameCn" :placeholder="$t('key1000423')" style="width: 250px; margin-right: 15px;"
        @on-enter="inputEnter" clearable/>
      <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
    </div>
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="500"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <template #footer>
      <Button @click="carrierTableModal = false">{{ $t('key1000248') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: "carrierModal",
  mixins: [Mixin],
  props: {
    modalTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        nameCn: '',
        trackingMoreCarrierCodeIds: [],
        type: null,
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000415'),
          key: 'name',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000416'),
          key: 'nameCn',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000417'),
          key: 'phone',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000418'),
          key: 'isEnabled',
          align: 'center',
          render: (h, params) => {
            let txt = params.row.isEnabled === '1'
              ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000419')
              : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000420');
            return h('span', txt);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 100,
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000421'),
                    show: v.getPermission('ymsPackageInfo_addLogisticsTracking'),
                    clickFn: () => {
                      let trackCarrierCode = params.row.code;
                      v.$emit('selectionData', trackCarrierCode);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width =Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      carrierTableModal: false,
    };
  },
  methods: {
    // 初始化数据
    initCarrierData() {
      this.getList();
      this.carrierTableModal = true;
    },
    // 查询
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 获取承运商的数据
    getList() {
      this.tableLoading = true;
      this.tableData = [];
      this.total = 0;
      this.axios.post(api.post_systemTrackingMoreCarrier_query, this.pageParams).then((res) => {
        this.tableLoading = false;
        if (res.data.code === 0) {
          let data = res.data.datas;
          this.total = data.total;
          this.tableData = data.list || [];
        }
      });
    },
    // 查询承运商
    inputEnter() {
      if (this.pageParams.nameCn !== '') {
        this.pageParams.pageNum = 1;
        this.pageParamsStatus = true;
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000422'));
        return false;
      }
    },
    // 监听承运商列表弹窗
    carrierTableModalChange(value) {
      if (!value) {
        this.pageParams.nameCn = '';
        this.pageParams.trackingMoreCarrierCodeIds = [];
        this.pageParams.type = null;
        this.pageParams.pageNum = 1;
        this.pageParams.pageSize = 10;
      }
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
};
</script>

<style lang="less" scoped>
/deep/ .carrierTableModalStyle {
  .ivu-modal-body {
    .carrier_table_filter {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
    }
  }
}
</style>
